import NotificationAdd from '../components/NotificationAdd.vue';
import NotificationEdit from '../components/NotificationEdit.vue';
import NotificationList from '../components/NotificationList.vue';
import NotificationHistory from '../components/NotificationHistory.vue';
import BulkNotificationEdit from '../components/BulkNotificationEdit.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: NotificationList,
    meta: {
      title: 'Notification List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'View Notifications'
        }
      ]
    }
  },
  {
    path: 'history',
    component: NotificationHistory,
    meta: {
      title: 'Notification History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Notifications'
        },
        {
          path: 'history',
          title: 'View Notification History'
        }
      ]
    }
  },
  {
    path: 'bulk-edit',
    component: BulkNotificationEdit,
    meta: {
      title: 'Bulk Edit Notifications',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'View Notifications'
        },
        {
          path: 'bulk-edit',
          title: 'Bulk Edit Notifications'
        }
      ]
    }
  },
  {
    path: 'add',
    component: NotificationAdd,
    meta: {
      title: 'Add Notification',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'View Notifications'
        },
        {
          path: 'add',
          title: 'Add Notification'
        }
      ]
    }
  },
  {
    path: ':notification',
    component: NotificationEdit,
    meta: {
      title: 'Edit Notification',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'View Notifications'
        },
        {
          path: '',
          title: 'Edit Notification'
        }
      ]
    }
  }
];
